import React, { useEffect, useRef, useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { useIntl } from 'react-intl';
import { Input } from 'antd';
import sha256 from 'crypto-js/sha256';
import moment from 'moment';

// inner js
import { KCSModal } from 'components';
import { HOME_PAGE, CNTTTB } from 'global/routes';
import { SECRET_KEY } from 'global/environment';
import { UserService } from 'services/UserService';

// image
import blue_vinaphone_logo from 'assets/landingPage/images/blue_vinaphone_logo.png';
import way_one from 'assets/landingPage/images/way_one.png';
import qrcode from 'assets/landingPage/images/qrcode.jpg';
import way_three from 'assets/landingPage/images/way_three.png';
import store_header from 'assets/landingPage/images/store_header.png';
import item_stored from 'assets/landingPage/images/item_stored.png';
import logo_footer from 'assets/landingPage/images/logo_footer.png';

// icon
import appstore_icon from 'assets/landingPage/icon/appstore_icon.png';
import req_icon from 'assets/landingPage/icon/req_icon.png';
import google_play_icon from 'assets/landingPage/icon/google_play_icon.png';
import icon_white_facebook from 'assets/landingPage/icon/icon_white_facebook.png';
import icon_white_youtube from 'assets/landingPage/icon/icon_white_youtube.png';
import icon_hand from 'assets/landingPage/icon/icon_hand.jpg';

import './style.scss';

// constant
const PARTNER_CODE = 'WEB';
const CURRENT_TIME_MILISECOND = moment().valueOf().toString();
const REGEX_PHONE_NUMBER = /^(0[3|5|7|8|9][0-9]{8}$)|(84[0-9]{9})$/;

function LandingPage() {
  const intl = useIntl();
  const { search } = useLocation();

  const phoneRef = useRef(null);

  const [msgError, setMsgError] = useState(null);
  const [reqMessage, setReqMessage] = useState('');
  const [isOpenModal, setIsOpenModal] = useState(false);
  const [paramMsisdn, setParamMsisdn] = useState('');

  useEffect(() => {
    const msisdn = new URLSearchParams(search).get('msisdn');
    const checkMsisdn = REGEX_PHONE_NUMBER.test(msisdn);
    if (!checkMsisdn || msisdn.length > 11) {
      return setParamMsisdn('');
    } else {
      setParamMsisdn(() => {
        if (msisdn.length === 11 && msisdn.startsWith('84')) return '0' + msisdn.slice(2);
        return msisdn;
      });
    }
  }, [search]);

  const encryptToken = (msisdn, request_id, partner_code, key) => {
    return sha256(msisdn + '|' + request_id + '|' + partner_code + '|' + key).toString();
  };

  const onSubmitRequest = (e) => {
    const test = REGEX_PHONE_NUMBER.test(phoneRef.current?.value);
    if (!test || phoneRef.current?.value.length > 11) {
      setMsgError(intl.formatMessage({ id: 'IDS_ERROR_ISDN_LONG' }));
      return;
    } else {
      setMsgError(null);
    }
    const obj = {
      msisdn: phoneRef.current?.value,
      request_id: CURRENT_TIME_MILISECOND,
      partner_code: PARTNER_CODE,
      token: encryptToken(phoneRef.current.value, CURRENT_TIME_MILISECOND, PARTNER_CODE, SECRET_KEY),
    };
    UserService.addContactUpdateUserInfor(obj, (res) => {
      setIsOpenModal(true);
      if (res.error_code === 0 && res.result) {
        // need update
        setReqMessage(res?.message);
      } else {
        setReqMessage(res?.message);
      }
    });
  };

  return (
    <div className='landing-page'>
      <div className='nadiWrapper'>
        <div className='ndwHeader' id='ndwHeader'>
          <section className='stnDheader'>
            <div className='container'>
              <div className='row align-items-center'>
                <div className='col-6 col-sm-6 col-md-4'>
                  <Link to={HOME_PAGE} className='bandlogo' title='Kết nối thông suốt trải nghiệm đỉnh cao'>
                    <img src={blue_vinaphone_logo} className='img-fluid' alt='Kết nối thông suốt trải nghiệm đỉnh cao' />
                  </Link>
                </div>
                <div className='col-6 col-sm-6 col-md-8'>
                  <div className='sbox'>
                    <ul className='scbox'>
                      <li>
                        <div className='cbox'>
                          <a href='tel:18001091' className='contact-link' title='Liên Hệ'>
                            <span className='icon-contact'></span>18001091
                          </a>
                        </div>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </section>
        </div>
        <div className='ndwBody'>
          <section className='stnRegway'>
            <div className='container'>
              <div className='nadi-panel'>
                <div className='nadi-panel-header'>
                  <h4 className='panel-title ispc'>Mời Quý khách Chuẩn hóa Thông tin thuê bao</h4>
                  <h4 className='panel-title ismob'>
                    Mời Quý khách <br /> Chuẩn hóa Thông tin thuê bao
                  </h4>
                  <p className='desc-top'>* Việc cập nhật Thông tin thuê bao là bắt buộc đối với khách hàng nhận được tin nhắn về việc chuẩn hóa lại Thông tin thuê bao của VinaPhone</p>
                </div>
                <div className='nadi-panel-body'>
                  <ul className='ulrow'>
                    <li>
                      <div className='way-item'>
                        <div className='way-header'>
                          <div className='way-header-title'>
                            <span className='triangle-bottomright'></span>
                            <span className='triangle-bottomleft'></span>
                            Cách 1
                          </div>
                        </div>
                        <div className='way-body'>
                          <div className='way-content align-items-center align-content-center'>
                            <h4 className='way-content-title'>Qua ứng dụng My VNPT</h4>
                            <div className='way-content-img'>
                              <img src={way_one} className='img-fluid' alt='cách 1' />
                            </div>
                            <div className='way-content-info'>
                              <div className='inner-content-info align-items-center'>
                                <div className='info-text'>
                                  Tải ứng dụng
                                  <br /> My VNPT bằng cách
                                  <br /> quét QR Code
                                </div>
                                <div className='info-link'>
                                  <a href='https://apps.apple.com/vn/app/my-vnpt/id1017188399?l=vi' target='_blank'>
                                    <img src={appstore_icon} className='img-fluid' />
                                  </a>
                                  <a href='https://play.google.com/store/apps/details?id=com.vnp.myvinaphone&hl=vi&pli=1' target='_blank'>
                                    <img src={google_play_icon} className='img-fluid' />
                                  </a>
                                </div>
                                <div className='info-qrcode'>
                                  <img src={qrcode} className='img-fluid' />
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </li>
                    <li>
                      <div className='way-item'>
                        <div className='way-header'>
                          <div className='way-header-title'>
                            <span className='triangle-bottomright'></span>
                            <span className='triangle-bottomleft'></span>
                            Cách 2
                          </div>
                        </div>
                        <div className='way-body d-flex align-items-center justify-content-center'>
                          <div className='way-content'>
                            <h4 className='way-content-title'>Qua website</h4>
                            <div className='way-content-link'>
                              <Link to={`${CNTTTB}${paramMsisdn.length !== 0 ? '?msisdn=' + paramMsisdn : ''}`} title='https://my.vnpt.com.vn'>
                                <span className='icon-web'></span> https://my.vnpt.com.vn
                              </Link>
                            </div>
                          </div>
                        </div>
                      </div>
                    </li>
                    <li>
                      <div className='way-item'>
                        <div className='way-header'>
                          <div className='way-header-title'>
                            <span className='triangle-bottomright'></span>
                            <span className='triangle-bottomleft'></span>
                            Cách 3
                          </div>
                        </div>
                        <div className='way-body'>
                          <div className='way-content align-items-center align-content-center'>
                            <h4 className='way-content-title'>Khách hàng mang theo CMND/CCCD tới điểm giao dịch VinaPhone gần nhất </h4>
                            <div className='way-content-img'>
                              <img src={way_three} className='img-fluid' alt='cách 3' />
                            </div>
                          </div>
                        </div>
                      </div>
                    </li>
                  </ul>
                </div>
                <div className='nadi-panel-footer d-flex align-items-center justify-content-center'>
                  <div className='footer-text'>
                    *Để tra cứu Thông tin Thuê bao, Quý khách hãy soạn <span>TTTB</span> gửi <span>1414</span>{' '}
                  </div>
                </div>
              </div>
            </div>
          </section>
          <section className='stnReq'>
            <div className='container'>
              <div className='row justify-content-center'>
                <div className='col-12 col-md-12 col-lg-10'>
                  <div className='reg-title'>Số điện thoại của Quý khách cần chuẩn hóa</div>
                  <div className='req-number'>{paramMsisdn}</div>
                  <div className='req-form d-flex align-items-center align-content-center flex-column'>
                    <div className='req-form-title'>
                      Quý khách cần tư vấn <span>Trực tiếp</span> vui lòng nhập Số điện thoại liên hệ:
                    </div>
                    <div className={'req-form-control ' + (msgError ? 'border-red' : '')}>
                      <div className='req-form-icon'>
                        <img src={req_icon} className='img-fluid' />
                      </div>
                      <div className='req-form-text'>
                        <input type='text' className='input-text' ref={phoneRef} />
                      </div>
                    </div>
                    {msgError && <div className='err-msg'>{msgError}</div>}
                    <div className='req-form-btn'>
                      <button type='button' className='btn btn-send' onClick={onSubmitRequest}>
                        gửi yêu cầu
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>

          <section className='stnStore'>
            <div className='container'>
              <div className='row justify-content-center'>
                <div className='col-12 col-md-10 col-lg-6'>
                  <div className='box-stored d-flex align-items-center align-content-center flex-column'>
                    <div className='store-header'>
                      <img src={store_header} className='img-fluid' />
                    </div>
                    <div className='store-link'>
                      <span>Qúy khách</span>{' '}
                      <span>
                        <Link to={`${CNTTTB}${paramMsisdn.length !== 0 ? '?msisdn=' + paramMsisdn : ''}`}>Nhấn tại đây</Link>
                      </span>
                      <span className='icon-store-link'>
                        <img src={icon_hand} />
                      </span>
                    </div>
                    <div className='store-and'>hoặc quét QR</div>
                    <div className='store-button'>
                      Tải và cập nhật tại app MY VNPT
                      <div className='store-item-img'>
                        <img src={item_stored} className='img-fluid' />
                      </div>
                    </div>
                    <div className='store-qrcode'>
                      <img src={qrcode} className='img-fluid' />
                    </div>
                  </div>
                </div>
              </div>{' '}
            </div>
          </section>

          <section className='stnCallnow'>
            <div className='container'>
              <div className='row justify-content-center'>
                <div className='col-12 col-md-12 col-lg-10'>
                  <div className='callnow-text'>
                    <div className='icon-check'></div>
                    Để biết được số điện thoại đang được chuẩn hóa, vui lòng nhấn <span>*110#</span> và bấm gọi đi.
                  </div>
                </div>
              </div>{' '}
            </div>
          </section>
        </div>
        <div className='ndwFooter'>
          <section className='stnCopyright pt-5 pb-4'>
            <div className='container footer'>
              <div className='row'>
                <div className='col-4 col-sm-6 col-md-6 logo '>
                  <img src={logo_footer} className='img-fluid' alt='Tập đoàn Bưu chính Viễn thông Việt Nam' />
                </div>
                <div className='col-8 col-sm-6 col-md-6 follow justify-content-lg-end justify-content-sm-left '>
                  <div className='d-flex align-items-center justify-content-end'>
                    Theo dõi chúng tôi: &nbsp;
                    <a href='https://www.facebook.com/vinaphonefan'>
                      <img src={icon_white_facebook} className='img-fluid' alt='Fanpage của VinaPhone' />
                    </a>
                    <a href='https://www.youtube.com/channel/UCCrkSbaFcot6hcLOuNADX8Q'>
                      <img src={icon_white_youtube} className='img-fluid' alt='Kênh youtube của VinaPhone' />
                    </a>
                  </div>
                </div>
              </div>
              <div className='row' style={{ paddingTop: 15 }}>
                <div className='col-12 col-md-12 copyright '>
                  <p>VNPT VinaPhone © 2022.</p>
                  <p>Giấy phép số: 62/GP-TTĐT do Bộ Thông tin - Truyền thông cấp ngày 09/04/2019.</p>
                  <p>Tập đoàn Bưu chính Viễn thông Việt Nam</p>
                  <p>Trụ sở: Tòa nhà VNPT, số 57 Phố Huỳnh Thúc Kháng, Phường Láng Hạ, Quận Đống Đa, Thành phố Hà Nội, Việt Nam</p>
                  <p>Mã số doanh nghiệp: 0100684378 do Sở Kế hoạch và Đầu tư TP.Hà Nội cấp ngày 22/10/2018</p>
                  <p>Giấy phép cung cấp dịch vụ viễn thông số 469/GP-BTTTT do Bộ Thông tin và Truyền thông cấp ngày 14/10/2016</p>
                  <p>Giấy phép cung cấp dịch vụ viễn thông số 18/GP-CVT do Bộ Thông tin và Truyền thông cấp ngày 18/01/2018</p>
                </div>
              </div>
            </div>
          </section>
        </div>
      </div>
      <KCSModal
        isOpenModal={isOpenModal}
        title='Thông báo'
        content={<div>{reqMessage}</div>}
        closeModal={() => {
          setIsOpenModal(false);
        }}
      />
    </div>
  );
}

export default LandingPage;
